import * as betgalaxy from './Betslip.styles.betgalaxy';
import * as betprofessor from './Betslip.styles.betprofessor';
import * as betroyale from './Betslip.styles.betroyale';
import * as fiestabet from './Betslip.styles.fiestabet';
import * as goldenrush from './Betslip.styles.goldenrush';
import * as juicybet from './Betslip.styles.juicybet';
import * as puntcity from './Betslip.styles.puntcity';
import * as puntgenie from './Betslip.styles.puntgenie';
import * as questbet from './Betslip.styles.questbet';
import * as sterlingparker from './Betslip.styles.sterlingparker';
import * as vikingbet from './Betslip.styles.vikingbet';
import * as volcanobet from './Betslip.styles.volcanobet';
import * as forsport from './Betslip.styles.forsport';
import * as junglebet from './Betslip.styles.junglebet';
import * as oldgill from './Betslip.styles.oldgill';
import * as sugarcastle from './Betslip.styles.sugarcastle';
import * as buffalobet from './Betslip.styles.buffalobet';
import * as wellbet from './Betslip.styles.wellbet';
import * as titanbet from './Betslip.styles.titanbet';
import * as slambet from './Betslip.styles.slambet';
import * as gigabet from './Betslip.styles.gigabet';
import * as templebet from './Betslip.styles.templebet';
import * as betstride from './Betslip.styles.betstride';
import * as goldenbet888 from './Betslip.styles.goldenbet888';
import * as hyperbet from './Betslip.styles.hyperbet';
import * as bet777 from './Betslip.styles.bet777';
import * as chromabet from './Betslip.styles.chromabet';
import * as bet575 from './Betslip.styles.bet575';
import * as epicodds from './Betslip.styles.epicodds';
import * as pyramidbet from './Betslip.styles.pyramidbet';
import * as magnumbet from './Betslip.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  wellbet,
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  templebet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
